import React, { Component } from "react";
import cookie from "react-cookies";
import BookingAndCancellationCard from "./BookingAndCancellationCard";
class CancelBooking extends Component {
  constructor(props) {
    let UserId = "";
    if (cookie.load("UserId")) {
      UserId = cookie.load("UserId");
    }
    super(props);
    this.state = {
      pageFor: "cancellation",
      userId: UserId,
      isMobile: window.innerWidth <= 480,
    };
  }

  render() {
    return (
      <>
        <BookingAndCancellationCard
          pageFor={this.state.pageFor}
          state={this.state}
          setState={this.setState}
        />
      </>
    );
  }
}

export default CancelBooking;
